import splitVoucherModalTemplate from '../views/modals/split-voucher-modal.tpl.html';
import createResidualVoucherModalTemplate from '../views/modals/create-residual-voucher-modal.tpl.html';
import voucherSingleMessageModalCreator
    from "../../../../modules/messages/helpers/voucher-single-message-modal-creator";

class VoucherScannerController {
    constructor(Alert, $stateParams, $http, $state, NavService, $uibModal, Acl, $translate, FileSaver, $injector) {
        this.alert = Alert;
        this.stateParams = $stateParams;
        this.api = $http;
        this.state = $state;
        this.navService = NavService;
        this.voucher = null;
        this.modal = $uibModal;
        this.acl = Acl;
        this.translate = $translate;
        this.fileSaver = FileSaver;
        this.injector = $injector;

        this.searchModel = '';
        this.loading = false;
        this.notFound = false;
        this.scanInProgress = false

        this.foundVoucherModel = null;
        this.enableAutoScan = false;

        this.successAudio = new Audio('/audio/success.mp3');
        this.errorAudio = new Audio('/audio/error.mp3');
    }

    async findVoucherByModel(e) {
        e.preventDefault();
        this.foundVoucherModel = null;
        this.loading = true;
        this.notFound = false;

        let response
        try {
            response = await this.api.post('vouchers/find-for-scan', {
                voucher_number: this.searchModel
                    .replace("-10", '-20')
                    .replace("-40", '-50')
                    .replace("-80", '-90')
            })
        } catch (e) {
            if (e.status === 404) {
                this.notFound = true;
            } else {
                this.alert.handle(e);
            }
            this.errorAudio.play();
            this.loading = false;
            return;
        }


        this.foundVoucherModel = response.data.data;

        this.searchModel = '';
        this.loading = false;
        if(this.enableAutoScan) {
            await this.useFoundVoucher();
        }
        document.getElementById('voucher-scan-input').focus();
    }

    async useFoundVoucher() {
        if(this.foundVoucherModel.status !== 'ok') {
            this.alert.error('Error', 'Can not use voucher. current status: ' + this.foundVoucherModel.status);
            this.errorAudio.play();
            return;
        }
        this.scanInProgress = true
        let response
        try {
            response = await this.api.post(`vouchers/${this.foundVoucherModel.id}/use-voucher`)
        } catch (e) {
            this.alert.error('Error', 'Can not use voucher');
            this.scanInProgress = false
            this.errorAudio.play();
            return;
        }
        this.successAudio.play();
        this.scanInProgress = false

        this.alert.success('Success', 'Voucher was used successful');
        this.foundVoucherModel = response.data.data;
    }

    goToVoucherDetails(voucher) {
        this.state.go('app.vouchers.main.details', {vid: voucher.id});
    }
}

VoucherScannerController.$inject = [
    'Alert',
    '$stateParams',
    '$http',
    '$state',
    'NavService',
    '$uibModal',
    'Acl',
    '$translate',
    'FileSaver',
    '$injector'
];

export default VoucherScannerController



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/controllers/scanner-controller.js